import {PayloadAction} from '@reduxjs/toolkit'
import {ContactsTypes, IActionContacts} from './types'
import {ContactsActions} from './index'
import {all, apply, put, takeLatest} from 'redux-saga/effects'
import contactsService from '../../services/contacts.service'
import {SnackbarActions, SnackBarMessageType} from "../snackbar";
import {AccessToken} from "../../application/domain/models/auth/access.token";
import authService from "../../services/auth";

/**
 * <h5>Generator functions that make calls to the contacts service to obtain the data.</h5>
 * @see {@link https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Statements/function*}
 * @typedef ContactsSaga
 * @namespace ContactsSaga
 * @category React
 * @subcategory Redux / Sagas
 */

/**
 * Generating function that calls  contacts.
 * @memberof ContactsSaga
 * @alias ContactsSaga.request
 * @function
 * @category React
 * @subcategory Redux / Sagas
 * @param {PayloadAction<IActionContacts>} action User triggered action data.
 */
export function* request(action: PayloadAction<IActionContacts>) {
    const {contactsFailure, contactsSuccess} = ContactsActions
    const { openSnackBar } = SnackbarActions

    try {
        const { filters } = action.payload
        if (filters?.phone) {
            let personContact = []
            let companyContact = []
            const accessToken: AccessToken = authService.decodeToken()
            const scope: string = accessToken.scope || ''
            const scopes = scope?.split(' ')
            if (scopes?.includes('pe:ra') || scopes?.includes('pe:r')) {
                // @ts-ignore
                personContact = yield apply(contactsService, contactsService.getPersonsByContacts, [filters.phone])
            }
            if (scopes?.includes('cp:ra') || scopes?.includes('cp:r')) {
                // @ts-ignore
                companyContact = yield apply(contactsService, contactsService.getCompanyByContacts, [filters.phone])
            }

            const data = [
                ...personContact.map((item: any) => {
                    return {
                        name: item.name,
                        document: item.cpf,
                        email: item.email,
                        phone: item.phone,
                        municipality: item.municipality,
                        uf: item.uf,
                        origin: item.origin
                    }
                }),
                ...companyContact.map((item: any) => {
                    return {
                        name: item.name,
                        document: item.cnpj,
                        email: item.email,
                        phone: item.phone,
                        municipality: item.municipality,
                        uf: item.uf,
                        origin: item.origin
                    }
                })
            ]


            yield put(contactsSuccess({
                data
            }))
        } if (filters?.email) {
            // @ts-ignore
            const personContact = yield apply(contactsService, contactsService.getPersonsByContacts, [filters.email])
            const companyContact = yield apply(contactsService, contactsService.getCompanyByContacts, [filters.email])

            const data = [
                ...personContact.map((item: any) => {
                    return {
                        name: item.name,
                        document: item.cpf,
                        email: item.email,
                        phone: item.phone,
                        municipality: item.municipality,
                        uf: item.uf,
                        origin: item.origin
                    }
                }),
                ...companyContact.map((item: any) => {
                    return {
                        name: item.name,
                        document: item.cnpj,
                        email: item.email,
                        phone: item.phone,
                        municipality: item.municipality,
                        uf: item.uf,
                        origin: item.origin
                    }
                })
            ]

            yield put(contactsSuccess({
                data
            }))
        }

    } catch (err: any) {
        yield put(contactsFailure())
        yield put(openSnackBar({ type: SnackBarMessageType.ERROR, title: 'Erro.', message: 'Ocorreu um erro ao buscar contatos.' }))
    }
}

const contactsSaga = function* (){
    yield all([
        takeLatest(ContactsTypes.CONTACTS_REQUEST, request),
    ])
}

export default contactsSaga
